export { default as audioLoadingIcon } from './audio-loading-icon.svg';
export { default as audioPlayIcon } from './audio-play-icon.svg';
export { default as audioPlayingIcon } from './audio-playing.gif';
export { default as audioReloadIcon } from './audio-reload-icon.svg';
export { default as audioDisableIcon } from './audio-disable-icon.svg';
